import  { useContext } from "react";
import { useNavigate } from "react-router-dom";
import PreviewItemCarrito from "./PreviewItemCarrito";
import { CartContext } from "@context/CardContext";
import { useTranslation } from "@hooks/useTranslation";

const Component = () => {

  const navigate = useNavigate();

  const producto = JSON.parse(localStorage.getItem('addPrevent'));
  const { totalQuantity,totalPay } = useContext(CartContext);
  const { translate } = useTranslation();
  
  const remove= ()=>{
    navigate("/detalles-producto/" + producto.uri, { 
      state: { scrollToInteresarte: true } 
    });
  }

  return (
    <>
      <section className="AgregadoCarrito">
        <div>
          <div className="icon-Check"></div>
          <h3>
            {translate('cart.title1')}
            <br />  {translate('cart.title2')}
          </h3>
          {<PreviewItemCarrito producto={producto} />}
          <p className="FontMedium">
          {translate('cart.title3')} {totalQuantity}  {translate('cart.title4')}  <b>${totalPay}</b>
          </p>

          <div
            className="ButtonDarkMedium"
            onClick={() => navigate("/carrito")}
          >
            <i className="icon-Trolley"></i>
            {translate('cart.title5')}
          </div>
          <div
            className="ButtonLightMedium"
            onClick={() => {remove()}}
          >
             {translate('cart.title6')}
          </div>
        </div>
      </section>
    </>
  );
};

export default Component;
